import React from "react";
import {NavLink} from "react-router-dom";

import '../../../css/styles.css';

export default function TryTraining(props) {

    return (
      <div
        key="main_page_try_training"
        className="slider-wrapper slider-content slide slide-try-training current "
        style={{ background: `url('${props.tryTrainingImage}') no-repeat center center` }}
      >
        <div className="inner">
          <h1>Vyzkoušej trénink</h1>
          <p>Vyber lokalitu a zkus si trénink zdarma. Pro kluby: objednej si ukázkový trénink zdarma.</p>
          <button>
            <NavLink to= "/try-training">
              Více informací
            </NavLink>
          </button>
          </div>
      </div>
    );

}
